import { createAction } from '@reduxjs/toolkit'
import { FiltrePlantillesType } from 'store/reducers/FiltrePlantillesReducer'

export const setFiltrePlantilles = createAction<FiltrePlantillesType>('setFiltrePlantilles')
export const resetFiltrePlantilles = createAction('resetFiltrePlantilles')
